/**
 * 全局通用的 interface, 给模糊的类型更清晰与语义的定义
 * @author Kody
 */

/**
 * 秒
 */
export type Second = number;

/**
 * 毫秒
 */
export type Millisecond = number;

/**
 * 无约束 keyName，value 类型明确的 Object
 */
export interface IUnclearKeyObj<T> {
    [key: string]: T;
}

/**
 * 未知结构的对象
 */
export type UnknownObj = IUnclearKeyObj<unknown>;

/**
 * 开关 - 0 | 1
 */
export type SwitchNum = 0 | 1;

/**
 * 开关 - '0' | '1'
 */
export type SwitchString = '0' | '1';

/**
 * 用 0 和 1 表示 true or false
 */
 export enum NUMBER_BOOL {
    FALSE,
    TRUE
}